var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"privacy-policy-container"},[_c('div',{staticClass:"container my-5 py-5",attrs:{"block-type":"block-rich-text","page-id":"6"}},[_vm._m(0),_c('article',{staticClass:"pt-5 fs-18",domProps:{"innerHTML":_vm._s(_vm.privacyHtml)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"h1"},[_vm._v("Privacy policy")])])
}]

export { render, staticRenderFns }